import React from 'react';
import { Button, Form, Input } from 'reactstrap';
import PropTypes from 'prop-types';

const Searchbar = ({ term, handleSearch, toggleForm }) => {
    return (
        <div className="d-flex my-3">
            <Form className="w-100 mr-2">
                <Input
                    type="text"
                    placeholder='Enter search term'
                    value={term}
                    onChange={(e) => handleSearch(e.target.value)}
                />
            </Form>
            <Button color="success" onClick={toggleForm} >
                New
            </Button>
        </div>
    );
};

Searchbar.propTypes = {
    term: PropTypes.string.isRequired,
    handleSearch: PropTypes.func.isRequired,
    toggleForm: PropTypes.func.isRequired
};

export default Searchbar;